import { Gondor } from "../Gondor";

const ACTIONS = {
  PROFESSION: "/profession/",
  PROFESSION_ITEM: "/profession/{id}/",
  ADD_SYSTEMS: "/profession/add/system",
  REMOVE_SYSTEMS: "/profession/remove/system",
};

export function find(params?: object) {
  return Gondor.API.get(ACTIONS.PROFESSION, { params });
}

export function findOne(id: number | string) {
  id = id.toString();
  return Gondor.API.get(ACTIONS.PROFESSION_ITEM.replace("{id}", id));
}

export function create(body: object) {
  return Gondor.API.post(ACTIONS.PROFESSION, body);
}

export function update(id: number | string, body: object) {
  id = id.toString();
  return Gondor.API.patch(ACTIONS.PROFESSION_ITEM.replace("{id}", id), body);
}

export function destroy(id: number | string) {
  id = id.toString();
  return Gondor.API.delete(ACTIONS.PROFESSION_ITEM.replace("{id}", id));
}

export function addSystems(body: object) {
  return Gondor.API.post(ACTIONS.ADD_SYSTEMS, body);
}

export function removeSystems(body: object) {
  return Gondor.API.post(ACTIONS.REMOVE_SYSTEMS, body);
}
